import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Finishers: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.75 43.72">
            <g>
                <path fill={color} d="M42.61,25.46l.98-.89h0s0,0,0,0v-6.86H.15v6.85l-.02.02.99.89-1.12.64v5.41l5.3-2.55.84-.37v-4.02h31.46v4.02l1.04.46h.01s5.1,2.44,5.1,2.44v-5.39l-1.13-.65ZM1.24,29.54v-2.71l.85-.49,2.02,1.82-2.87,1.38ZM4.9,27.2l-2.92-2.63h2.92v2.63ZM13.98,20.26l-1.3,2.44H2.01v-3.13h12.66l-.4.75-.27-.11-.02.04ZM15.91,20.97l-.02.04-.91,1.7h-.9l1.06-1.99.27.11.02-.04.64-1.21h.9l-.8,1.5-.27-.11ZM17.83,21.71l-.02.04-.51.95h-.9l.66-1.24.27.11.02-.04,1.04-1.95h.9l-1.19,2.24-.27-.11ZM18.71,22.71l.27-.5.27.11.02-.04,1.44-2.69h21.03v3.13h-23.03ZM38.85,24.57h2.9l-2.9,2.62v-2.62ZM42.51,29.52l-2.86-1.37,2-1.81.86.49v2.69Z"/>
                <polygon fill={color} points="29.69 .2 27.87 .61 29.67 8.58 14.94 6.93 8.77 0 7.37 1.24 14.02 8.7 20.96 9.48 20.96 16.8 22.82 16.8 22.82 9.69 32.07 10.72 29.69 .2"/>
                <polygon fill={color} points="25.01 25.6 23.15 25.6 23.15 32.75 25.01 34.51 25.01 25.6"/>
                <polygon fill={color} points="21.4 25.6 19.54 25.6 19.54 43.72 21.4 41.96 21.4 25.6"/>
                <path fill={color} d="M21.89,6.51c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06-3.06,1.37-3.06,3.06,1.37,3.06,3.06,3.06ZM21.89,2.25c.66,0,1.2.54,1.2,1.2s-.54,1.2-1.2,1.2-1.2-.54-1.2-1.2.54-1.2,1.2-1.2Z"/>
            </g>
        </svg>
    );
};

export default Finishers;
